import { helpers } from 'vuelidate/lib/validators'

export const alphaSpace = helpers.regex('alphaSpace', /^[a-zA-Z ]*$/)
export const noWhiteSpaceAtStartOrEnd = helpers.regex('noWhiteSpaceAtStartOrEnd', /^[^\s]+(\s+[^\s]+)*$/)
export const contains = (lookingFor) =>
  helpers.withParams({ type: 'contains', lf: lookingFor }, function (value, parentVm) {
    const checkAgainst = this[lookingFor].toLowerCase()
    return value.toLowerCase().includes(checkAgainst)
  })
export const mustBeTrue = (values) => {
  let hasTrue = false
  if (values !== undefined) {
    values.forEach((isChecked) => {
      if (isChecked) {
        hasTrue = isChecked
      }
      return true
    })
  } else {
    console.log('no values')
  }
  return hasTrue
}
export const notDisabled = (value) => {
  return value !== 'disabled'
}
